// Part F motion: clone each showcase wall once so every track is exactly
// twice one set, then enable the loop (row 2 keeps its static stagger).
export const initShowcaseDuet = () => {
    const showcase = document.getElementById("showcase");
    if (showcase === null || showcase.dataset.motionDuet === "true") {
        return;
    }
    const tracks = showcase.querySelectorAll(".showcase-track");
    if (tracks.length === 0) {
        return;
    }
    tracks.forEach(track => {
        const walls = Array.from(track.children).filter(el => {
            return el.classList && el.classList.contains("showcase-wall");
        });
        if (walls.length === 0) {
            return;
        }
        walls.forEach(wall => {
            const twin = wall.cloneNode(true);
            twin.setAttribute("aria-hidden", "true");
            twin.querySelectorAll("img").forEach(img => {
                img.setAttribute("alt", "");
            });
            track.appendChild(twin);
        });
    });
    showcase.dataset.motionDuet = "true";
    showcase.classList.add("motion-duet");
};
